export default "__VITE_ASSET__CWJctrLf__"